import { render, staticRenderFns } from "./view-student-fee-structure.vue?vue&type=template&id=39b2135c"
import script from "./view-student-fee-structure.vue?vue&type=script&lang=js"
export * from "./view-student-fee-structure.vue?vue&type=script&lang=js"
import style0 from "./view-student-fee-structure.vue?vue&type=style&index=0&id=39b2135c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports